import { useTracking } from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';
import { routes } from '@/constants/primaryNavigation';
import { MobileFooterMenuWrapper, MobileFooterMenuItem } from './styled';
import { slugify } from '@utilities/slugify';
import { ROUTE_HOME } from '@/constants/routes';
import { useCompanyShareLink } from '@/hooks/useCompanyShareToken';
import useUser from '@/hooks/useUser';
import { useHomeRoute } from '@/hooks/useHomeRoute';

export interface MobileFooterMenuProps {
  location: string;
}

export const MobileFooterMenu = ({ location }: MobileFooterMenuProps) => {
  const { isSharedCompany } = useCompanyShareLink();
  const { data: user } = useUser();
  const { trackEvent } = useTracking();
  const shouldHideFooterMenu = !user.loggedIn && isSharedCompany;
  const homeRoute = useHomeRoute();
  if (shouldHideFooterMenu) return null;
  return (
    <MobileFooterMenuWrapper as="nav">
      {routes.map(({ label, icon, to, matches }) => {
        const selected = matches.includes(location);
        return (
          <MobileFooterMenuItem
            key={`mobile-footer-menu-item-${slugify(label)}`}
            column
            col={2}
            alignItem="center"
            justifyContent="flex-start"
            displayFlex
            selected={selected}
          >
            <RouterLink
              inheritColor
              noUnderline
              to={{
                type: to === ROUTE_HOME ? homeRoute : to,
              }}
              onClick={() => {
                trackEvent({
                  type: 'track',
                  subject: 'primaryNavMobile',
                  modifier: label,
                  action: 'click',
                });
              }}
            >
              <p>{matches.includes(location) ? icon[0] : icon[1]}</p>
              <span>{label}</span>
            </RouterLink>
          </MobileFooterMenuItem>
        );
      })}
    </MobileFooterMenuWrapper>
  );
};
